module.exports = {"id":"203505","name":"Joe Bryan","rating":"75","photo":"./data/images/photos/4/203505.png","club":{"name":"Bristol City","logo":"./data/images/clubs/BristolCity.png"},"positions":["DG","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoeBryan0.json
// module id = 2046
// module chunks = 0